import {BridgeType, resolveBridgeType} from './BridgeApi';
import launcherLauncher from './launcher/launcher.launcher';
import launcherWeb from './web/launcher.web';
import launcherMock from './mock/launcher.mock';

export interface LauncherBridge {
    getAccessToken(): Promise<string>;
    requestSignIn(redirectUrl: string): Promise<void>;
    isSSOEnabled(): Promise<boolean>;
    setSSOEnabled(value: boolean): Promise<void>;
}

const bridges = {
    [BridgeType.LAUNCHER]: launcherLauncher,
    [BridgeType.WEB]: launcherWeb,
    [BridgeType.MOCK]: launcherMock
};

export default (): LauncherBridge => bridges[resolveBridgeType()];
